<template>
    <div class="editing-dfs">
        <div class="mb-3">
            <span class="rounded bgray-700 text-light f-85 fw-500 px-2 py-1"> {{sub_code}} </span>
        </div>
        <div class="border-bottom pb-4 mb-4">
            <h5 class="mb-2">기본 정보</h5>
            <slot name="head"></slot>
        </div>

        <template v-if="!noStructure">
            <div class="border-bottom pb-4 mb-4">
                <div class="mb-2">
                    <h5 class="d-inline-block mr-2">문항(Structure)</h5>
                    <template v-if="sub_guide">
                        <fa :id="`sub-structure-guide-popover-${sub_code}`" class="d-inline-block" icon="info-circle"></fa>
                    </template>

                    <template v-if="sub_guide">
                        <b-popover
                            :target="`sub-structure-guide-popover-${sub_code}`"
                            title="정의"
                            triggers="hover focus"
                            placement="left"
                            :content="sub_guide"
                            >
                        </b-popover>
                    </template>
                </div>
                <slot name="structure"></slot>
            </div>
        </template>

        <div class="border-bottom pb-4 mb-4">
            <h5 class="d-inline-block mb-3">세부 옵션</h5>
            <slot name="option"></slot>
        </div>

        <div class="mb-1">
            <slot name="footer"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'EditingSubFrame',
    components: {},
    props: {
        sub_code: {
            required: true,
            type: String,
            default: '미지정'
        },
        sub_type: {
            required: true,
            type: String
        },
        sub_guide: {
            type: String,
            default: ''
        },
        noStructure: {
            type: [Boolean, String],
            default: (_noStructure) => typeof _noStructure === 'undefined'
                ? false
                : _noStructure === ''
                    ? true
                    : _noStructure
        }
    },
    data() {
        return {}
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
}
</script>
